import { render, staticRenderFns } from "./userGradeTask.vue?vue&type=template&id=2b047a9e&scoped=true&"
import script from "./userGradeTask.vue?vue&type=script&lang=js&"
export * from "./userGradeTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b047a9e",
  null
  
)

export default component.exports